module.exports = __webpack_public_path__ + "static/media/ga.5e3984e0.png";